import { render } from "./MorseCode.vue?vue&type=template&id=66c73846&scoped=true"
import script from "./MorseCode.vue?vue&type=script&lang=js"
export * from "./MorseCode.vue?vue&type=script&lang=js"

import "./MorseCode.vue?vue&type=style&index=0&id=66c73846&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66c73846"]])

export default __exports__